import { useAccount } from "@qw/auth";
import { useProductQuery } from "@qw/graphql";
import { INTERNAL_ROLES, PRODUCT_EDIT_ROLES } from "@qw/qw-common";
import { Spinner } from "@qw/ui";
import type { FC } from "react";
import { useParams } from "react-router";

import { ProductForm } from "./product-form";

export const ProductEditor: FC = () => {
  const params = useParams();
  const { user } = useAccount();

  const productId = params.productId ?? null;

  const {
    data: productData,
    loading,
    refetch: refetchProduct,
  } = useProductQuery({
    variables: { id: productId as string },
    skip: !productId,
  });

  const product = productData?.product ?? null;
  // Check if user has any of the roles allowed to edit products (shared with backend)
  const canEdit = user.roles.some((role) => (PRODUCT_EDIT_ROLES as readonly string[]).includes(role));
  const canManageContacts = user.roles.some((role) => (INTERNAL_ROLES as readonly string[]).includes(role));

  return (
    <>
      {loading && !product && <Spinner />}
      {product && (
        <ProductForm
          canEdit={canEdit}
          canManageContacts={canManageContacts}
          product={product}
          refetchProduct={refetchProduct}
        />
      )}
    </>
  );
};
